import { useEffect, useState } from 'react';
import './landing.css';
import { Reveal, Counter } from './hooks';
import HeroMock from './HeroMock';
import SystemOverview from './SystemOverview';
import SecurityDiagram from './SecurityDiagram';

const Mark = ({ size = 30 }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden="true"><polygon points="4,6 30,6 50,78 70,6 96,6 61,100 39,100" fill="#D0202E" /><polygon points="50,78 61,100 39,100" fill="#96101C" /></svg>
);
const goDemo = () => { window.location.hash = '#/demo'; };
const scrollTo = id => e => { e.preventDefault(); document.getElementById(id).scrollIntoView({ behavior: 'smooth' }); };

const FLOW = [['ERP', 'Müşteri ve ürün bilgisi'], ['Excel', 'Fiyat ve hesaplama'], ['Belge', 'PDF / teklif hazırlama'], ['E-posta', 'Müşteriye gönderim']];
const HOW = [['Anlama', 'Müşteri, ürün ve miktar'], ['Veri', 'ERP / Excel eşleştirmesi'], ['Kontrol', 'Plan, yetki ve onay'], ['Çıktı', 'Teklif PDF’i ve işlem kaydı']];
const TRUST = [
  ['Mevcut sistemi korur', 'Yeni bir ERP kurmadan, kaynaklara adaptör yaklaşımıyla bağlanmak üzere tasarlanır.'],
  ['Onayı merkeze alır', 'Kritik yazma ve dışa gönderim adımları kullanıcı kontrolünden geçecek şekilde planlanır.'],
  ['İzlenebilirlik sunar', 'Komutun, adımların ve sonuçların denetim kaydıyla ilişkilendirilmesi hedeflenir.']
];
const STATS = [[4, 'TRL', 'Teknoloji olgunluğu', 'Kontrollü prototip ortamı'], [8, '', 'MVP ürün arayüzü', 'Komut, teklif, onay ve denetim'], [4, '', 'Temel kullanım senaryosu', 'Teklif · stok · sipariş · analiz'], [3, '', 'Pilot firma hedefi', '12 haftalık gerçek saha planı']];
const NEXT = [['ERP ile kontrollü entegrasyon', 'Mevcut kaynaklara adaptörle bağlanıp veri eşleşmesini doğrulamak.'], ['Gerçek tekliflerle performans testi', 'Süreyi, doğruluğu ve kullanıcı onay akışını sahada ölçmek.'], ['Pilotlardan ürünleşmeye geçiş', 'Üç pilot hedefiyle kullanım ve iş birliği modelini doğrulamak.']];
const TEAM = [['Ali Özen', 'Yapay zekâ, ajan mimarisi ve ürün doğrulama', 'aliozen210@gmail.com'], ['Said Berk', 'Backend, entegrasyon ve veri katmanı', 'csaidberk@gmail.com']];

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 8);
    on(); window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);

  return (
    <div className="lp">
      <header className={'lp-head' + (scrolled ? ' scrolled' : '')}>
        <div className="lp-wrap lp-head-in">
          <a className="lp-brand" href="/" onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}><Mark /><b>VİZOVA</b></a>
          <nav className="lp-nav">
            <a href="#sistem" onClick={scrollTo('sistem')}>Sistem</a>
            <a href="#problem" onClick={scrollTo('problem')}>Problem</a>
            <a href="#nasil" onClick={scrollTo('nasil')}>Nasıl çalışır</a>
            <a href="#guven" onClick={scrollTo('guven')}>Güven</a>
            <a href="#guvenlik" onClick={scrollTo('guvenlik')}>Güvenlik</a>
            <a href="#durum" onClick={scrollTo('durum')}>Durum</a>
            <a href="#ekip" onClick={scrollTo('ekip')}>Ekip</a>
          </nav>
          <button className="lp-btn red sm" onClick={goDemo}>Demoya git</button>
        </div>
      </header>

      <section className="lp-hero">
        <div className="lp-wrap lp-hero-in">
          <div className="lp-hero-copy">
            <div className="lp-kicker">Yapay zekâ / akıllı iş operasyonları</div>
            <h1>ERP’niz aynı.<br />İş yapış şekliniz <span className="hl">değişiyor.</span></h1>
            <p>VİZOVA, üretici KOBİ’lerin mevcut ERP ve Excel verilerini Türkçe komutlarla çalışan, kullanıcı onaylı iş akışlarına dönüştüren yapay zekâ operasyon katmanıdır.</p>
            <div className="lp-cta">
              <button className="lp-btn red" onClick={goDemo}>Demoya git <span aria-hidden="true">→</span></button>
              <a className="lp-btn" href="#nasil" onClick={scrollTo('nasil')}>Nasıl çalışır</a>
            </div>
            <div className="lp-tag">Tek mesaj. Görünür plan. Kontrollü sonuç.</div>
          </div>
          <HeroMock />
        </div>
      </section>

      <section id="sistem" className="lp-sec soft">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Sisteme genel bakış</Reveal>
          <Reveal as="h2" delay={60}>Dağınık kaynaklar.<br />Tek bir teklif.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>VİZOVA, ERP sistemlerini ve ofis ile şube bilgisayarlarındaki Excel dosyalarını okur, veriyi eşleştirir ve teklif taslağını hazırlar. Siz onaylamadan hiçbir kayıt yazılmaz.</Reveal>
          <SystemOverview />
        </div>
      </section>

      <section id="problem" className="lp-sec">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Problemi anlıyoruz</Reveal>
          <Reveal as="h2" delay={60}>Tek bir teklif.<br />Birden fazla ekran.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>Müşteri kaydı ERP’de, fiyat hesabı Excel’de, belge başka bir yerde, gönderim e-postada. Her teklif için aynı bilgiler tekrar tekrar taşınıyor.</Reveal>
          <div className="lp-flow">
            {FLOW.map(([t, d], i) => (
              <Reveal key={t} className="lp-flow-item" delay={i * 130}>
                <span className="n">0{i + 1}</span><b>{t}</b><span>{d}</span>
              </Reveal>
            ))}
          </div>
          <Reveal className="lp-warn" delay={200}><span>Tekrarlı veri girişi</span><span>Geciken teklif · hata riski</span></Reveal>
          <Reveal className="lp-goal" delay={100}>
            <div className="lp-eyebrow red">VİZOVA ile hedeflediğimiz</div>
            <h3>Aynı sistemler. Tek bir operasyon akışı.</h3>
            <p>Odak: yüksek teklif hacmine sahip üretici KOBİ’ler, teklif ve satış operasyonları.</p>
          </Reveal>
        </div>
      </section>

      <section id="nasil" className="lp-sec soft">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Nasıl çalışıyor?</Reveal>
          <Reveal as="h2" delay={60}>Bir mesaj.<br />Kontrollü bir sonuç.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>Kullanıcı yalnızca istediği işi tarif eder. VİZOVA veriyi anlamlandırır, adımları planlar ve kritik işlemlerde kararı kullanıcıya bırakır.</Reveal>
          <Reveal className="lp-quote">“ABC firmasına 50 adet flanş için teklif hazırla.”</Reveal>
          <div className="lp-steps">
            {HOW.map(([t, d], i) => (
              <Reveal key={t} className="lp-step" delay={i * 120}>
                <span className="n">0{i + 1}</span><b>{t}</b><span>{d}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section id="guven" className="lp-sec dark">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow light">Teknoloji ve güven</Reveal>
          <Reveal as="h2" delay={60}>Yapay zekâ planlar.<br />Kontrol sizde kalır.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>VİZOVA’nın yaklaşımı yalnızca süreci hızlandırmak değil; işin nasıl yürüdüğünü görünür ve denetlenebilir hâle getirmektir.</Reveal>
          <Reveal className="lp-arch" delay={100}>
            {[['Komut', 'Türkçe talep'], ['YZ planı', 'Niyet + adımlar'], ['Kontrol', 'Kullanıcı onayı'], ['Çıktı', 'PDF + denetim']].map(([t, d]) => (
              <div key={t}><b>{t}</b><span>{d}</span></div>
            ))}
          </Reveal>
          <Reveal className="lp-sources" delay={150}>Mevcut veri kaynakları · ERP · Excel / CSV · E-posta</Reveal>
          <div className="lp-cards">
            {TRUST.map(([t, d], i) => (
              <Reveal key={t} className="lp-card" delay={i * 120}><span className="n">0{i + 1}</span><b>{t}</b><p>{d}</p></Reveal>
            ))}
          </div>
          <Reveal as="p" className="lp-note">Canlı ERP bağlantıları ve güvenlik kontrolleri pilot aşamasında doğrulanacaktır.</Reveal>
        </div>
      </section>

      <section id="guvenlik" className="lp-sec">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Güvenlik</Reveal>
          <Reveal as="h2" delay={60}>Verileriniz şirketinizin<br />dışına çıkmaz.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>VİZOVA on-prem çalışabilir; yapay zekâ modeli ve hosting için yerel seçenekler sunulur. Böylece veriler dış servislere çıkarılmaz. Ajanın her adımı agentic siber güvenlik önlemleriyle denetlenir.</Reveal>
          <SecurityDiagram />
          <Reveal as="p" className="lp-note">Güvenlik kontrolleri ve canlı ERP bağlantıları pilot aşamasında doğrulanacaktır.</Reveal>
        </div>
      </section>

      <section id="durum" className="lp-sec soft">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Bugün ve yarın</Reveal>
          <Reveal as="h2" delay={60}>Fikirden öte.<br />Ürüne dönüşen bir teknoloji.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>VİZOVA, çalışan prototip akışını ürün ekranları ve kontrol katmanıyla somutlaştırdı. Şimdi hedef, gerçek ERP ortamında ölçümlü pilotlara geçmek.</Reveal>
          <div className="lp-stats">
            {STATS.map(([n, pre, t, d], i) => (
              <Reveal key={t} className="lp-stat" delay={i * 100}>
                <div className="big">{pre && <small>{pre} </small>}<Counter to={n} />{i === 0 && <sup>*</sup>}</div>
                <b>{t}</b><span>{d}</span>
              </Reveal>
            ))}
          </div>
          <div className="lp-next">
            <Reveal className="lp-eyebrow">Sonraki doğrulama adımları</Reveal>
            {NEXT.map(([t, d], i) => (
              <Reveal key={t} className="lp-next-item" delay={i * 120}><span className="n">{i + 1}</span><div><b>{t}</b><span>{d}</span></div></Reveal>
            ))}
          </div>
          <Reveal as="p" className="lp-note">Bugünkü durum: MVP prototipi mevcut; gerçek ERP performansı pilotta ölçülecek. * TRL 4, prototip ortamına dayalı ekip değerlendirmesidir; bağımsız sertifikasyon değildir.</Reveal>
        </div>
      </section>

      <section className="lp-sec">
        <div className="lp-wrap">
          <Reveal className="lp-demo">
            <div>
              <div className="lp-eyebrow light">VİZOVA demo</div>
              <h2>Bir fikri değil,<br />ürün akışını keşfedin.</h2>
              <p>Demo sayfasını ziyaret edin ve VİZOVA’nın yaklaşımını yakından inceleyin.</p>
            </div>
            <button className="lp-btn white" onClick={goDemo}>Demoya git <span aria-hidden="true">→</span></button>
          </Reveal>
        </div>
      </section>

      <section id="ekip" className="lp-sec soft">
        <div className="lp-wrap">
          <Reveal className="lp-eyebrow">Ekip ve iletişim</Reveal>
          <Reveal as="h2" delay={60}>İşi konuşalım.<br />Geleceği birlikte kuralım.</Reveal>
          <Reveal as="p" className="lp-lead" delay={120}>VİZOVA, üretici KOBİ’lerin teklif süreçlerini daha yalın, hızlı ve kontrollü hâle getirme hedefiyle geliştiriliyor. Ürünü tanımak veya pilot iş birliğini görüşmek için bize ulaşın.</Reveal>
          <div className="lp-team">
            {TEAM.map(([n, r, m], i) => (
              <Reveal key={n} className="lp-person" delay={i * 120}>
                <div className="av">{n.split(' ').map(x => x[0]).join('')}</div>
                <b>{n}</b><span>{r}</span><small>Gazi Üni. · Bilg. Müh.</small>
                <a href={'mailto:' + m}>{m}</a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <footer className="lp-foot">
        <div className="lp-wrap"><span><Mark size={18} /> VİZOVA · Yapay zekâ operasyon asistanı</span><span>İnovaTİM 2026</span></div>
      </footer>
    </div>
  );
}
